import React from "react";
import { connect } from "react-redux";
import {
  Button,
  ButtonToolbar,
  Col,
  Glyphicon,
  Grid,
  Row,
} from "react-bootstrap";
import { GetSummary } from "./action";
import ReactJson from "react-json-view";
import Loader from "../../Loader";
import { Panel } from "../../Panel";
import { getFamilyUnitVersionInConfigurations } from "helper/utils";

class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isSaving: false,
    };
  }

  componentDidMount() {
    const familyUnitTypes = getFamilyUnitVersionInConfigurations(
      this.props.configurations
    );
    this.props
      .dispatch(
        GetSummary(
          this.props.configurations,
          this.props.firmwares,
          this.props.releaseHistory,
          familyUnitTypes.unitFamilyId,
          familyUnitTypes.unitTypeId,
          familyUnitTypes.unitVersionId,
          this.props.isMandatoryUpdate,
          this.props.configurationId  
        )
      )
      .then(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  onBack() {
    this.props.onBack();
  }

  async onSave() {
    this.setState({
      isSaving: true,
    });
    await this.props.onSave();
    this.setState({
      isSaving: false,
    });
  }

  render() {
    if (this.state.isLoading) {
      return <Loader fullpage message="Loading summary..." />;
    }

    return (
      <Grid fluid>
        <h1>Summary for {this.props.configName}</h1>
        <Row>
          <Col sm={12}>
            <Panel>
              <div class="panel-body">
                <div className="row">
                  <div className="col-sm-6">
                    <div class="form-group">
                      <label>Configuration</label>
                      <ReactJson
                        src={this.props.configuration}
                        name="configuration"
                        displayDataTypes={false}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div class="form-group">
                      <label>Recipe</label>
                      <ReactJson
                        src={this.props.recipe}
                        name="recipe"
                        displayDataTypes={false}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <ButtonToolbar className="pull-right">
                  <Button
                    bsStyle="primary"
                    id="btnBack"
                    onClick={() => {
                      this.onBack();
                    }}
                  >
                    <Glyphicon glyph="arrow-left" /> Back
                  </Button>
                  <Button
                    bsStyle="primary"
                    id="btnNext"
                    disabled={this.state.isSaving}
                    onClick={() => this.onSave()}
                  >
                    Save
                    {this.state.isSaving ? (
                      <span>
                        <i className="fa fa-spinner fa-spin" />
                      </span>
                    ) : (
                      <span></span>
                    )}
                  </Button>
                </ButtonToolbar>
              </div>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    configuration: state.configuration.summary.configuration,
    recipe: state.configuration.summary.recipe,
  };
};

export default connect(mapStateToProps)(Summary);
